import { defaultAssignmentVisualizationsFilters } from "@app/constants/filters.defaults.tsx";
import { ActiveEnums } from "@app/data/engine.ts";
import useAssignmentData from "@app/data-hooks/use-assignment-data.ts";
import { assignmentVisualizationsFiltersStore } from "@app/stores/filters.store.ts";
import { Box } from "@mui/material";
import { useStore } from "@tanstack/react-store";
import { Multiselect, QueryStatusRouter } from "bi-lib";
import { useEffect } from "react";
import { AssignmentBudgetByStaffChart } from "./charts/assignment-budget-by-staff.chart.tsx";
import FiltersContainer from "./filters-container.tsx";

interface Props {
    assignmentId: number;
}

export function AssignmentVisualizationsPanel({ assignmentId }: Props) {
    const { staffIds } = useStore(assignmentVisualizationsFiltersStore(assignmentId));

    const { rosterList } = useAssignmentData({ id: assignmentId, activeState: ActiveEnums.All });

    useEffect(() => {
        if (rosterList.data == undefined || staffIds != undefined) {
            return;
        }
        assignmentVisualizationsFiltersStore(assignmentId).setState((prev) => ({
            ...prev,
            staffIds: rosterList.data!.map((x) => x.staffId!),
        }));
    }, [rosterList.data]);

    return (
        <Box>
            <FiltersContainer
                onReset={() =>
                    assignmentVisualizationsFiltersStore(assignmentId).setState(
                        () => defaultAssignmentVisualizationsFilters,
                    )
                }
            >
                <QueryStatusRouter queryHook={rosterList}>
                    <Multiselect
                        label={"Staff"}
                        options={rosterList.data?.map((x) => ({
                            label: `${x.displayName}${!x.active ? " (I)" : ""}`,
                            value: x.staffId!,
                        }))}
                        value={staffIds}
                        onChange={(value) =>
                            assignmentVisualizationsFiltersStore(assignmentId).setState((prev) => ({
                                ...prev,
                                staffIds: value,
                            }))
                        }
                        fullWidth
                    />
                </QueryStatusRouter>
            </FiltersContainer>
            <AssignmentBudgetByStaffChart assignmentId={assignmentId} staffIds={staffIds} />
        </Box>
    );
}
